<template>
  <div class="bg-[whitesmoke]">
    <slot />
  </div>
</template>
